import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FullPageLoader from "./FullPageLoader/FullPageLoader.jsx";
import About from "../pages/About/About.jsx";
// import LoggedUserRoute from "../LoggedUserRoute.jsx";
const LoggedUserRoute = lazy(() => import("../LoggedUserRoute.jsx"));
const Layout = lazy(() => import("../components/Layout/Layout.jsx"));
const TeachersList = lazy(() =>
  import("../pages/TeachersList/TeachersList.jsx")
);
const PlatformBenefitsPage = lazy(() =>
  import("../pages/PlatformBenefitsPage/PlatformBenefitsPage.jsx")
);
const PrivacyPolicy = lazy(() =>
  import("../pages/PrivacyPolicy/PrivacyPolicy.jsx")
);
const LoginPage = lazy(() => import("../pages/LoginPage/LoginPage.jsx"));
const RegisterPage = lazy(() =>
  import("../pages/RegisterPage/RegisterPage.jsx")
);
const TeacherPublicProfile = lazy(() =>
  import("../pages/TeacherPublicProfile/TeacherPublicProfile.jsx")
);
const StudentPublicProfile = lazy(() =>
  import("../pages/StudentPublicProfile/StudentPublicProfile.jsx")
);
const UserFeedbackForm = lazy(() =>
  import("../pages/UserFeedbackForm/UserFeedbackForm.jsx")
);
const AvailableSlotsPage = lazy(() =>
  import("../pages/AvailableSlotsPage/AvailableSlotsPage.jsx")
);
const HomePage = lazy(() => import("../pages/HomePage/HomePage.jsx"));
const PageNotFound = lazy(() =>
  import("../pages/PageNotFound/PageNotFound.jsx")
);
const ChatHome = lazy(() => import("../pages/ChatHome/ChatHome.jsx"));
const ChatLayout = lazy(() => import("../pages/ChatLayout/ChatLayout.jsx"));
const ResetPasswordPage = lazy(() =>
  import("../pages/ResetPasswordPage/ResetPasswordPage.jsx")
);
const ForgotPasswordPage = lazy(() =>
  import("../pages/ForgotPasswordPage/ForgotPasswordPage.jsx")
);
const VerifyStudentEmailPage = lazy(() =>
  import("../pages/VerifyStudentEmailPage/VerifyStudentEmailPage.jsx")
);
const VerifyTeacherEmailPage = lazy(() =>
  import("../pages/VerifyTeacherEmailPage/VerifyTeacherEmailPage.jsx")
);
const MyFavoriteStudents = lazy(() =>
  import("../pages/MyFavoriteStudents/MyFavoriteStudents.jsx")
);
const MyFavoriteTeachers = lazy(() =>
  import("../pages/MyFavoriteTeachers/MyFavoriteTeachers.jsx")
);
const TeacherCalendar = lazy(() =>
  import("../pages/TeacherCalendar/TeacherCalendar.jsx")
);
const StudentCalendar = lazy(() =>
  import("../pages/StudentCalendar/StudentCalendar.jsx")
);
const TeacherDashboard = lazy(() =>
  import("../pages/TeacherDashboard/TeacherDashboard.jsx")
);
const TeacherInfoSection = lazy(() =>
  import("../components/TeacherInfoSection/TeacherInfoSection.jsx")
);
const TeacherLessonInfoSection = lazy(() =>
  import("../components/TeacherLessonInfoSection/TeacherLessonInfoSection.jsx")
);
const VideoSection = lazy(() =>
  import("../components/VideoSection/VideoSection.jsx")
);
const TeacherBookings = lazy(() =>
  import("../pages/TeacherBookings/TeacherBookings.jsx")
);
const StudentDashboard = lazy(() =>
  import("../pages/StudentDashboard/StudentDashboard.jsx")
);
const StudentProfileSection = lazy(() =>
  import("../components/StudentProfileSection/StudentProfileSection.jsx")
);
const StudentBookings = lazy(() =>
  import("../pages/StudentBookings/StudentBookings.jsx")
);
const PricingPage = lazy(() => import("../pages/PricingPage/PricingPage.jsx"));
const LessonCreateSection = lazy(() =>
  import("../pages/LessonCreateSection/LessonCreateSection.jsx")
);
const StudentAvailableSlots = lazy(() =>
  import("../components/StudentAvailableSlots/StudentAvailableSlots.jsx")
);
const VideoCall = lazy(() => import("../components/VideoCall/VideoCall.jsx"));
const PrivateRouteTeacher = lazy(() => import("../PrivateRouteTeacher.jsx"));
const PrivateRouteStudent = lazy(() => import("../PrivateRouteStudent.jsx"));
const PrivateRouteUser = lazy(() => import("../PrivateRouteUser.jsx"));
const PublicOnlyRoute = lazy(() => import("../PublicOnlyRoute.jsx"));
const TeacherScorePage = lazy(() =>
  import("../components/TeacherScorePage/TeacherScorePage.jsx")
);
// const RefundPolicy = lazy(() =>
//   import("../pages/RefundPolicy/RefundPolicy.jsx")
// );
const Faq = lazy(() => import("../pages/Faq/Faq.jsx"));
const DonationSuccessPage = lazy(() =>
  import("../pages/DonationSuccessPage/DonationSuccessPage.jsx")
);
const TermsOfUse = lazy(() => import("../pages/TermsOfUse/TermsOfUse.jsx"));
const UserInstructionsPage = lazy(() =>
  import("../pages/UserInstructionsPage/UserInstructionsPage.jsx")
);


const I18nRoutes = () => {
  const SupportedLanguages = ["en", "de", "uk", "ru", "fr"];
  const { i18n } = useTranslation();
  // const currentLang = i18n.language || "en";
  const baseLang = (i18n.language || "").split("-")[0];

  
  const defaultLang = "en";
   // Проверка, входит ли в список поддерживаемых
   const currentLang = SupportedLanguages.includes(baseLang)
     ? baseLang
     : defaultLang;

  return (
    <Suspense
      fallback={
        <>
          <FullPageLoader />
        </>
      }
    >
      <Routes>
        <Route path="/" element={<Navigate to={`/${currentLang}`} replace />} />

        {SupportedLanguages.map((lang) => (
          <Route path={`/${lang}`} key={lang}>
            <Route element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="teachers" element={<TeachersList />} />
                <Route
                path="donation-success"
                element={<DonationSuccessPage />}
              />
              <Route path="teachers/:id" element={<TeacherPublicProfile />} />
              <Route
                path="student/:id"
                element={
                  <PrivateRouteTeacher>
                    <StudentPublicProfile />
                  </PrivateRouteTeacher>
                }
              />
              <Route path="benefits" element={<PlatformBenefitsPage />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms" element={<TermsOfUse />} />
              <Route path="instructions" element={<UserInstructionsPage />} />
              <Route path="about" element={<About />} />
              <Route
                path="login"
                element={
                  <LoggedUserRoute>
                    <LoginPage />
                  </LoggedUserRoute>
                }
              />
              {/* <Route path="login" element={<LoginPage />} /> */}

              <Route
                path="register"
                element={
                  <LoggedUserRoute>
                    <RegisterPage />
                  </LoggedUserRoute>
                }
              />
              {/* <Route path="register" element={<RegisterPage />} /> */}
              <Route
                path="feedback"
                element={
                  <PrivateRouteUser>
                    <UserFeedbackForm />
                  </PrivateRouteUser>
                }
              />
            
              <Route path="available-slots" element={<AvailableSlotsPage />} />
              <Route
                path="chat"
                element={
                  <PrivateRouteUser>
                    <ChatHome />
                  </PrivateRouteUser>
                }
              />
              <Route
                path="chat/:userId"
                element={
                  <PrivateRouteUser>
                    <ChatLayout />
                  </PrivateRouteUser>
                }
              />
              <Route
                path="students-profile"
                element={
                  <PrivateRouteStudent>
                    <StudentDashboard />
                  </PrivateRouteStudent>
                }
              >
                <Route index element={<StudentProfileSection />} />
              </Route>
              <Route
                path="student-bookings"
                element={
                  <PrivateRouteStudent>
                    <StudentBookings />
                  </PrivateRouteStudent>
                }
              />
              <Route
                path="teacher-bookings"
                element={
                  <PrivateRouteTeacher>
                    <TeacherBookings />
                  </PrivateRouteTeacher>
                }
              />
              <Route
                path="favourite-students"
                element={
                  <PrivateRouteTeacher>
                    <MyFavoriteStudents />
                  </PrivateRouteTeacher>
                }
              />
              <Route
                path="favourite-teachers"
                element={
                  <PrivateRouteStudent>
                    <MyFavoriteTeachers />
                  </PrivateRouteStudent>
                }
              />
              <Route
                path="teacher-dashboard"
                element={
                  <PrivateRouteTeacher>
                    <TeacherDashboard />
                  </PrivateRouteTeacher>
                }
              >
                <Route index element={<TeacherInfoSection />} />

                <Route
                  path="lesson-info"
                  element={<TeacherLessonInfoSection />}
                />
                <Route path="videos" element={<VideoSection />} />
                <Route path="score" element={<TeacherScorePage />} />
              </Route>
              <Route path="faq" element={<Faq />} />
              <Route
                path="lesson-create"
                element={
                  <PrivateRouteTeacher>
                    <LessonCreateSection />
                  </PrivateRouteTeacher>
                }
              />
              <Route path="video/:bookingId" element={<VideoCall />} />
              <Route path="teachers-subscription" element={<PricingPage />} />
              {/* <Route path="refund-policy" element={<RefundPolicy />} /> */}
              <Route
                path="verify-student-email"
                element={<VerifyStudentEmailPage />}
              />
              <Route
                path="verify-teacher-email"
                element={<VerifyTeacherEmailPage />}
              />
              <Route
                path="student-calendar"
                element={
                  <PrivateRouteStudent>
                    <StudentCalendar />
                  </PrivateRouteStudent>
                }
              />
              <Route
                path="teacher-calendar"
                element={
                  <PrivateRouteTeacher>
                    <TeacherCalendar />
                  </PrivateRouteTeacher>
                }
              />
              <Route
                path="forgot-password"
                element={
                  <LoggedUserRoute>
                    <ForgotPasswordPage />
                  </LoggedUserRoute>
                }
              />
              <Route
                path="reset-password"
                element={
                  <LoggedUserRoute>
                    <ResetPasswordPage />
                  </LoggedUserRoute>
                }
              />
              <Route path="bookings" element={<StudentAvailableSlots />} />
            </Route>
          </Route>
        ))}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default I18nRoutes;
